import { useSwipeBack } from "@/shared/hooks/useSwipeBack";
import { SwipeBackIndicator } from "@/shared/components/common/SwipeBackIndicator";

export function SwipeBackHandler() {
  const { isSwiping, swipeProgress, direction } = useSwipeBack();

  return <SwipeBackIndicator isVisible={isSwiping && direction === "right"} progress={swipeProgress} />;
}
